export default {
  branches: {
    is: 'Útibúaþjónusta',
    en: 'Branches',
  },
  atms: {
    is: 'Hraðbankar og sjálfsafgreiðsla',
    en: 'ATMs',
  },
};
